import moment from "moment";
import {
    Box,
    Paper,
    TextField,
    Button,
    Grid,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Divider,
    Autocomplete,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export default function AuditSearch({ filters, setFilters, onSearch, onClear, ruleEnums, stores = [], skus = [] }) {
    const setSearchFilter = (key, value) => {
        if (key === "startDate" && filters.endDate && value && moment(value).isAfter(moment(filters.endDate))) {
            return;
        }

        if (key === "endDate" && filters.startDate && value && moment(value).isBefore(moment(filters.startDate))) {
            return;
        }

        if (key === "storeId") {
            setFilters((prev) => ({ ...prev, storeId: value, productItemId: "" }));
            return;
        }
        setFilters((prev) => ({ ...prev, [key]: value }));
    };

    const toSentenceCase = (value) => {
        return value
            .toLowerCase()
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    return (
        <Paper
            elevation={3}
            sx={{
                position: "sticky",
                top: 0,
                zIndex: 1000,
                p: 3,
                backgroundColor: "#fff",
                borderBottom: "1px solid #eee",
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="h5">Audit</Typography>
            </Box>
            <Divider sx={{ mb: 2 }} />

            <LocalizationProvider dateAdapter={AdapterMoment}>
                <Grid container spacing={2} alignItems="stretch">
                    <Grid item size={{ xs: 12, sm: 6, md: 2 }}>
                        <DatePicker
                            label="Start Date"
                            value={filters?.startDate ? moment(filters.startDate, "YYYY-MM-DD") : null}
                            onChange={(newValue) =>
                                setSearchFilter("startDate", newValue ? newValue.format("YYYY-MM-DD") : null)
                            }
                            slotProps={{ textField: { fullWidth: true, size: "small" } }}
                        />
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 6, md: 2 }}>
                        <DatePicker
                            label="End Date"
                            value={filters?.endDate ? moment(filters.endDate, "YYYY-MM-DD") : null}
                            onChange={(newValue) =>
                                setSearchFilter("endDate", newValue ? newValue.format("YYYY-MM-DD") : null)
                            }
                            slotProps={{ textField: { fullWidth: true, size: "small" } }}
                        />
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <FormControl fullWidth size="small" required error={!filters?.entityType}>
                            <InputLabel id="audit-search-rule-type-label">Entity Type</InputLabel>
                            <Select
                                labelId="audit-search-rule-type-label"
                                value={filters?.entityType ?? ""}
                                label="Rule Type"
                                onChange={(e) => setSearchFilter("entityType", e.target.value)}
                            >
                                {Object.keys(ruleEnums?.AuditEntityType ?? {}).map((key) => (
                                    <MenuItem key={key} value={key}>
                                        {toSentenceCase(key)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Entity Id"
                            value={filters?.entityId ?? ""}
                            onChange={(e) => setSearchFilter("entityId", e.target.value)}
                            placeholder="Please enter an Entity Id"
                            required
                            error={!filters?.entityId}
                        />
                    </Grid>

                    {/* <Grid item size={{ xs: 6, md: 2 }}>
                        <Autocomplete
                            fullWidth
                            size="small"
                            options={stores}
                            value={stores.find((s) => String(s.storeId) === String(filters?.storeId)) || null}
                            isOptionEqualToValue={(option, selected) =>
                                String(option.storeId) === String(selected.storeId)
                            }
                            getOptionLabel={(option) => `${option?.storeId} - ${option?.storeName || ""}`}
                            onChange={(_, selectedStore) => setSearchFilter("storeId", selectedStore?.storeId ?? "")}
                            renderInput={(params) => <TextField {...params} label="Store" />}
                        />
                    </Grid> */}

                    {/* <Grid item size={{ xs: 6, md: 2 }}>
                        <Autocomplete
                            fullWidth
                            size="small"
                            disabled={!filters?.storeId}
                            options={skus}
                            value={skus.find((s) => String(s.id) === String(filters?.productItemId)) || null}
                            isOptionEqualToValue={(option, selected) =>
                                String(option.id) === String(selected.id)
                            }
                            getOptionLabel={(option) => `#${option?.id} - ${option?.name || ""}`}
                            onChange={(_, selectedSku) => setSearchFilter("productItemId", selectedSku?.id ?? "")}
                            renderInput={(params) => <TextField {...params} label="Product Item ID" />}
                        />
                    </Grid> */}

                    <Grid item size={{ xs: 12, md: 2 }}>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1}}>
                            <Button
                                variant="contained"
                                startIcon={<SearchIcon />}
                                onClick={onSearch}
                                disabled={!(filters?.entityType && filters?.entityId)}
                            >
                                Search
                            </Button>

                            <Button variant="outlined" color="inherit" startIcon={<ClearIcon />} onClick={onClear}>
                                Clear
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </LocalizationProvider>
        </Paper>
    );
}
